import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M14 8h1v8","key":"svg-1"}]]

const IconNumber11Small = createReactComponent('outline', 'number-11-small', 'Number11Small', __iconNode);

export default IconNumber11Small;